import queryString from "query-string";

// Parse the URL query string, lowercasing KEYS but preserving VALUES exactly.
//
// Every call site used to do queryString.parse(location.search.toLowerCase()),
// which lowercased the whole string and so destroyed the case of every value.
// That silently broke the advertising click ids: Google Ads matches offline
// conversions on the exact gclid and Meta matches fbc on the exact fbclid, and a
// lowercased one never matches. Measured before this change: 2,750 gclids and
// 31,596 fbclids captured, not one containing a single uppercase character, so
// none of them were usable.
//
// Keys are still lowercased so existing lookups (queries.utm_source, queries
// .gclid) keep working no matter how the parameter was typed in the URL. Only
// the values change, and they change by being left alone.
export const parseQueryParams = (search) => {
  const parsed = queryString.parse(search || "");
  const out = {};
  Object.keys(parsed).forEach((key) => {
    out[key.toLowerCase()] = parsed[key];
  });
  return out;
};

export default parseQueryParams;
